import { InteractiveMap } from '../components/property/InteractiveMap';
import { useI18n } from '../i18n';

export function MapPage() {
  const { language } = useI18n();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2">
            {language === 'sr' ? 'Interaktivna mapa nekretnina' : 'Interactive Property Map'}
          </h1>
          <p className="text-slate-600 dark:text-slate-400">
            {language === 'sr' 
              ? 'Pregledajte sve oglase na mapi. Uvećajte željeni region za precizniju pretragu.'
              : 'Browse all listings on the map. Zoom into your desired region for a more precise search.'}
          </p>
        </div>
        
        <InteractiveMap />
      </div>
    </div>
  );
}
